<div class="grid h-full">
    <div class="lg:col-4 lg:col-offset-4 md:col-6 md:col-offset-3 sm:col-6 sm:col-offset-3  m-auto text-center">
      <div class="p-lg-10 p-md-5" *ngIf="is_locked_out">
        <h3>You have been logged out</h3>
        <h4>{{message}}</h4>
      </div>
        <div class="p-lg-10 p-md-2" *ngIf="!is_locked_out">
            <h3  *ngIf="reset_pin">Enter Secure PIN</h3>
            <h3  *ngIf="!reset_pin">Verify OTP</h3>
            <h5 class="mb-3"  *ngIf="reset_pin">Enter your Bizpay security code</h5>
            <h5 class="mb-3" *ngIf="!reset_pin">Enter the OTP to reset PIN</h5>
            <p  *ngIf="!reset_pin">
              An OTP has been sent to your mobile number ending in <strong>xxxxxx{{mobile | slice:-4}}</strong> to reset your security code. This is a security measure to ensure that only authorized users can reset their code
              </p>
            <p  *ngIf="reset_pin">This code is necessary for accessing sensitive app features, including viewing the wallet screen, loading money into wallets etc.</p>
          <ng-otp-input
            #otpInput
            (onInputChange)="onOtpChange($event)"
            [config]=config
          ></ng-otp-input>
          <div class="text-right mr-5 mt-1" *ngIf="reset_pin">
            <span class="text-primary pointer" (click)="resetPin()">Forgot PIN?</span>
          </div>
          <div class="mt-3 mb-1">
            <small *ngIf="message" [ngClass]="message.status ? 'text-success': 'text-danger'">{{message.message}}</small>
          </div>

          <div class="button-gap" >
            <p-button label="Cancel" type="button" class="inline-block w-50 mx-auto" styleClass="p-button-outlined w-full" (click)="cancelPin()" *ngIf="reset_pin"></p-button>
            <p-button label="Cancel" type="button" styleClass="p-button-outlined mx-3" (click)="cancelPin()" *ngIf="!reset_pin"></p-button>
            <!-- <p-button label="Verify PIN" styleClass="px-4" (click)="checkPin()" *ngIf="reset_pin" [disabled]="pin?.length !=4"></p-button> -->
            <p-button label="Submit OTP" styleClass="px-4" (click)="verifyOTP()" *ngIf="!reset_pin" [disabled]="pin?.length !=4"></p-button>
          </div>
        </div>
    </div>


</div>
